import { RouterView } from "vue-router";
import { SetupRouting } from "@/views/work-manage/setup/setup.routing";
import { PresentRouting } from "@/views/work-manage/present/present.routing";
import { BudgetRouting } from "@/views/work-manage/budget/budget.routing";
import { ProgressRouting } from "@/views/work-manage/progress/progress.routing";
import { ProjectWorkRouting } from "@/views/work-manage/project-work/project-work.routing";
import { ProjectPlanRouting } from "@/views/work-manage/project-plan/project-plan.routing";
import { ProjectDocumentRouting } from "@/views/work-manage/project-document/project-document.routing";
import { LogRouting } from "@/views/work-manage/log/log.routing";

export const WorkManageRouting = {
  path: "/work-manage",
  name: "work-manage",
  redirect: "/work-manage/setup/list",
  component: RouterView,
  meta: { title: "施工管理", icon: "shigong" },
  children: [
    ...SetupRouting,
    ...PresentRouting,
    ...BudgetRouting,
    ...ProjectWorkRouting,
    ...ProjectPlanRouting,
    ...LogRouting,
    ...ProgressRouting,
    ...ProjectDocumentRouting,
  ],
};
